import React, { useEffect, useState } from "react";
import style from "./style";
import {
  Box,
  Grid,
  InputLabel,
  // Select,
  // MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Button,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import Modal from "../../components/Modal";
import {ReactComponent as Edit}from "../../assets/images/edit.svg";
// import countryList from "react-select-country-list";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { formatDate } from "../../utils/DateFormat";

const UifPage = ({ getUif, deleteUif, CreateUif, handleEditUifs, uifCountry }) => {
  // const options = countryList().getData();
  const [open, setOpen] = useState(false);
  const [datefrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState()
  const [opens, setOpens] = useState(false);
  const [value, setValue] = useState();
  const [fixed, setFixed] = useState();
  const [rate, setRate] = useState();
  const [maxCap, setMaxCap] = useState();
  const [countryTax, setCountryTax] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [isDisabled, setIsDisabled] = useState(true);
  // const location = useLocation();
  // const {uifCountry} = location.state||{};

  useEffect(() => {
    if (!open) {
      setIsEdit(false);
      setSelectedId(null);
      setFixed("");
      setRate("");
      setMaxCap("");
      setDateFrom(null);
      setDateTo(null);
    }
  }, [open]);


  useEffect(() => {
    if (isEdit) {
     
      setIsDisabled(
        !fixed || !rate || !maxCap || !datefrom || !dateTo || 
        (fixed === selectedId.fixed &&
         rate === selectedId.rate &&
         maxCap === selectedId.maxCap &&
         dayjs(datefrom).isSame(dayjs(selectedId.datefrom)) &&
         dayjs(dateTo).isSame(dayjs(selectedId.dateTo))
        )
      );
    } else {
  
      setIsDisabled(!fixed || !rate || !maxCap || !datefrom || !dateTo);
    }
  }, [fixed, rate, maxCap, datefrom, dateTo, selectedId, isEdit]);

  const handleDeleteItem = () => {
    deleteUif(value)
    setOpens(false);
  };

  const deleteData = (item) => {
    setValue(item);
  };

  const handleEdit = (item) => {
    setIsEdit(true);
    setOpen(true);
    setSelectedId(item._id);
    setFixed(item.employerUIF);
    setRate(item.employeeUIF);
    setMaxCap(item.maxCap);
    setDateFrom(item.startYear ? dayjs(item.startYear) : null);
    setDateTo(item.endYear ? dayjs(item.endYear) : null);
    setCountryTax(uifCountry);
  };

  const handleSubmit = () => {
    if (isEdit) {
      
      handleEditUifs(selectedId, fixed, rate, countryTax, datefrom, dateTo, maxCap);
    } else {
      
      CreateUif(fixed, rate, countryTax, datefrom, dateTo, maxCap);
    }
    setOpen(false);
  };


  return (
    <>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 ,mt:3,ml:3,mr:2}}>
        <Typography sx={style.gridText}>UIF Tables</Typography>
        <Button
          variant="contained"
          type="submit"
          color="success"
          sx={style.jobButtons}
          onClick={() => {
            setOpen(true)
            setCountryTax(uifCountry)
          }}
        >+ Add
        </Button>
      </Box>
      <Grid container sx={style.mainContainer}>
        <Grid item xs={12} lg={12} sx={style.gridbox}>
          <Typography sx={style.gridTexttable}>{uifCountry}</Typography>

          <TableContainer sx={style.noShadow}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={style.tableHead}>Employer UIF</TableCell>
                  <TableCell sx={style.tableHead}>Employee UIF</TableCell>
                  <TableCell sx={style.tableHead}>Max Cap</TableCell>
                  <TableCell sx={style.tableHead}>Start Year</TableCell>
                  <TableCell sx={style.tableHead}>End Year</TableCell>
                  <TableCell sx={style.tableHead}>Update Date</TableCell>
                  <TableCell sx={style.TableHead}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {getUif?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  getUif?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell sx={style.tableData}>
                        {item?.employerUIF}
                      </TableCell>
                      <TableCell sx={style.tableData}>
                        {item?.employeeUIF}
                      </TableCell>
                      <TableCell sx={style.tableData}>
                        {item?.maxCap}
                      </TableCell>
                      <TableCell sx={style.tableData}>
                        {formatDate(item?.startYear)}
                      </TableCell>
                      <TableCell sx={style.tableData}>
                        {formatDate(item?.endYear)}
                      </TableCell>
                      <TableCell sx={style.tableData}>
                        {formatDate(item?.updatedAt)}
                      </TableCell>
                      <TableCell sx={style.tabledata}>
                        <Box sx={style.tableActiondata}>
                          <Edit onClick={() => handleEdit(item)} style={{ cursor: "pointer",margin:3 }} />
                          <DeleteOutlineIcon
                            sx={{ color: "#ff0000" }}
                            onClick={() => {
                              deleteData(item?._id), setOpens(true);
                            }}
                          />
                         
                        </Box>
                        
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Modal
        open={open}
        setOpen={setOpen}
        disabled={isDisabled}
        btnText={isEdit ? "Update UIF" : "Add UIF"} title={"UIF"} handleCheck={handleSubmit}
      >
        <Box sx={style.modalGrid}>  
          <Box sx={style.boxs2}>
            <InputLabel sx={style.label}>Employee</InputLabel>
            <TextField
              name="desc"
              value={fixed}
              onChange={(e) => {
                setFixed(e.target.value);
              }}
              style={style.boxs2}
            />
          </Box>
          <Box sx={style.boxs2}>
            <InputLabel sx={style.label}>Employer</InputLabel>
            <TextField
              name="desc"
              value={rate}
              onChange={(e) => {
                setRate(e.target.value);
              }}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Start Year</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}  >
              <Box >
                <DatePicker
                  value={datefrom}
                  slotProps={{
                    field: {
                      readOnly: true
                    }
                  }}
                  sx={style.calenderInput}
                  onChange={(newValue) => { setDateFrom(newValue); }}
                />
              </Box>
            </LocalizationProvider>
          </Box>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>End Year</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs} >
              <DatePicker
                value={dateTo}
                slotProps={{
                  field: {
                    readOnly: true
                  }
                }}
                sx={style.calenderInput}
                onChange={(newValue) => { setDateTo(newValue); }}
              />
            </LocalizationProvider>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%",ml:"5px" }}>
            <InputLabel sx={style.label}>Max Cap</InputLabel>
            <TextField
              name="desc"
              value={maxCap}
              required
              onChange={(e) => {
                setMaxCap(e.target.value);
              }}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      <Modal
        open={opens}
        setOpen={setOpens}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete UIF"}
        handleDelete={handleDeleteItem}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};

export default UifPage;
